import { useAuth } from 'hooks/use-auth'
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface Props {
  children: ReactNode
}

const ProtectedRoute = (props: Props) => {
  let location = useLocation()
  const { isAuth } = useAuth()

  if (!isAuth) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return <>{props.children}</>
}

export default ProtectedRoute
